import { render, staticRenderFns } from "./ProjectTransition.vue?vue&type=template&id=17337b58&scoped=true&"
import script from "./ProjectTransition.vue?vue&type=script&lang=js&"
export * from "./ProjectTransition.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTransition.vue?vue&type=style&index=0&id=17337b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17337b58",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProjectIntro: require('/opt/build/repo/components/project/ProjectIntro.vue').default})
